export const sections = [
  "Flights",
  "Accomodation",
  "Job Resources",
  "Useful Tools",
];

const flights = [
  {
    title: "Skyscanner",
    url: "https://www.skyscanner.com/",
    img: "skyscanner.webp",
    description:
      "This is my favorite flight search engine of all time. They always seem to find the best deals, and their calendar view shows you which days are the most affordable to fly. They appeal to me because they search small booking sites that no one else does. Begin all flight searches with them.",
  },
  {
    title: "Momondo",
    url: "https://www.momondo.com/",
    img: "momondo.webp",
    description:
      "This fantastic website searches a wide range of airlines, including many low-cost carriers that larger sites overlook. While I always start with Skyscanner, I'll also check this site to compare prices.",
  },
  {
    title: "Google Flights",
    url: "https://www.google.com/travel/flights",
    img: "google-flights.webp",
    description:
      "Google Flights allows you to enter your departure airport and view flights all over the world on a map to determine the cheapest destination. It's a useful search engine for learning about routes, connections, and fares.",
  },
];

const accomodations = [
  {
    title: "Hostel World",
    url: "https://www.hostelworld.com/",
    img: "hostelworld.webp",
    description:
      "This is the best hostel accommodation website available, with the most inventory, the best search interface, and the greatest availability. I use them for all of my hostel reservations. ",
  },
  {
    title: "Booking.com",
    url: "https://www.booking.com/",
    img: "bookingdotcom.png",
    description:
      "Booking probably has the world's largest selection of low-cost lodging. They consistently found the cheapest rooms in our studies. I also like their user-friendly interface and no-money-down policy. They are particularly useful for listings in developing countries.",
  },
  {
    title: "Airbnb",
    url: "https://www.airbnb.com/",
    img: "airbnb.webp",
    description:
      "This website connects you with homeowners that rent out their homes/apartments to you. You'll have all the conveniences of home plus the opportunity to stay in a less-touristy section of town for a fraction of the price of a hotel room.",
  },
  {
    title: "Agoda",
    url: "https://www.agoda.com/",
    img: "agodanew.jpg",
    description:
      "This should be your primary lodging website for Asian guesthouses and motels. They have the most extensive inventory and the most competitive prices.",
  },
  {
    title: "Couschsurfing",
    url: "https://www.couchsurfing.com/",
    img: "coachsurfing.webp",
    description:
      "This website allows you to stay for free on people's sofas or spare rooms. It's a terrific way to save money while meeting locals who know far more about a destination than a hostel or hotel. Even if you don't want to stay with someone, the app can help you locate really enjoyable local meet-ups.",
  },
];

const working: {}[] = [
  {
    title: "HelpX",
    url: "https://www.helpx.net/",
    img: "helpx.webp",
    description:
      "When traveling, one of the finest locations to locate job and volunteer opportunities is HelpX. They have farms, farmstays, homestays, B&Bs, hostels, and sailing vessels that welcome volunteers to stay with them for a short period of time in exchange for food and lodging.",
  },
  {
    title: "WorkAway",
    url: "https://www.workaway.info/",
    img: "work-away-info.webp",
    description:
      "This is yet another fantastic job search website! Workaway is similar to HelpX, except this website includes more paid employment options for when you travel, as well as volunteer opportunities.",
  },
  {
    title: "WWOOF",
    url: "https://www.wwoof.net/",
    img: "WWOOF.jpg",
    description:
      "WWOOF (Worldwide Opportunities on Organic Farms) is a program that links you with farms all over the world where you may work for room and board in exchange for room and board. It's an excellent resource for budget travelers on the road for an extended period of time!",
  },
];

const tools = [
  {
    title: "Rome2Rio",
    url: "https://www.rome2rio.com/",
    img: "rome2rio.webp",
    description:
      "This website shows you how to go from point A to point B in the most efficient and cost-effective way feasible. Simply input your departure and arrival points, and it will show you all of the bus, rail, aircraft, and boat options available to you, as well as how much they cost. One of the most excellent transportation websites available!",
  },
  {
    title: "Lonely Planet",
    url: "https://www.lonelyplanet.com/",
    img: "lonely-planet.webp",
    description:
      "Everyone has a favorite travel handbook. I own Lonely Planet. I enjoy the design of their guides, as well as their organization, minimal weight, and concentration on low-cost travel. Lonely Planet's books were also revamped in 2011, and they are now better structured, with more images and maps.",
  },
  {
    title: "Worlds Nomad Insurance",
    url: "https://www.worldnomads.com/",
    img: "world-nomads.webp",
    description:
      "World Nomads is where I get all of my travel insurance. They provide excellent customer service, fair pricing, and comprehensive coverage. I've been using them since 2003, when I first started traveling.",
  },
];

export const information = [flights, accomodations, working, tools];
